<template>
	<div>
        <div class="yx-color-text-primary">{{ formatTime?.date | formatEmpty }}</div>
        <div class="yx-color-text-secondary">{{ formatTime?.time | formatEmpty}}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	computed: {
		formatTime() {
			const date = this.row.addTime.slice(0, 10) || '';
			const time = this.row.addTime.slice(11, this.row.length) || '';
			return {
				date,
				time,
			};
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="less" scoped></style>
